<template>
  <div class="spinner--container">
    <div class="spinner">
      <img src="@/assets/img/spinner.gif" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
}
</script>

<style scoped>
.spinner--container {
  align-items: center;
  background: rgb(255, 255, 255, 0.4);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  transition: opacity 0.3s linear;
  width: 100%;
  z-index: 9999;
}
.spinner > img {
  display: block;
  max-width: 100%;
  width: 150px;
}

@media screen and (min-width: 1024px) {
  .spinner--container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    transition: opacity 0.3s linear;
    width: 100%;
    z-index: 9999;
  }
  .spinner {
    width: 100px;
    height: 100px;
    padding: 10px;
    background-color: var(--white);
    border-radius: 13px;
  }
}
</style>
